import React from 'react'

/**
 * 用户隐私条款弹窗内容
 */
export default function PrivacyPolicy () {
  return (
    <div className='policyContainer'>
      <div className='textTitle'>优e+营养餐解决方案隐私政策</div>
      <div className='textPre'>
        <div>本优e+营养餐解决方案隐私政策（以下简称为“本政策”）仅适用索迪斯优e+营养餐解决方案（以下简称为“本系统”）所涉及个人信息的处理目的、范围、方式等，并列明了您对于本系统中所收集的您的个人信息的相关权利。</div>
        <div>最新更新日期：2022年1月10日</div>
        <div>如果您有任何疑问、意见或建议，请通过以下联系方式与我们联系：
          <div>电子邮件：dpo.china@sodexo.com</div>
          <div>电话：021-23566888</div>
        </div>
        <div>
          <span className='bold'>【引言】</span>
        </div>
        <p>
          索迪斯（以下或称“我们”）非常注重保护用户（以下或称“您”）的个人信息及隐私，我们也深知个人信息对用户的重要性，并会按照法律法规的要求和业界成熟的安全标准，采取相应的安全保护措施来保护您的个人信息。我们希望通过本政策向您清晰地介绍在使用我们的服务时，我们如何处理您的个人信息，以及我们为您提供的访问、更正、删除和保护这些信息的方式或途径。
        </p>
        <p>
          鉴此，我们制定本政策并提醒您：
        <span className='bold'>请在使用我们的产品和/或服务前，仔细阅读并了解本政策，特别应重点阅读我们以粗体标识的条款，在确认充分理解并同意后方使用相关的产品和/或服务。</span>我们将按照本政策收集、处理以及披露您的信息。如对本政策的内容有任何疑问、意见或建议，您可通过本政策中提供的联系方式与我们取得联系。
        </p>
        <p>
        <span className='bold'>  如果您不同意按照本政策所述方式处理您的个人信息，请不要在收到请求时提供您的个人信息，并停止使用该系统。继续使用该系统即表示您确认我们在本政策中所列明的有关您个人信息的规定。</span>
        </p>
      </div>
      <div className='textTable'>
        <p>目录</p>
        <ol className='tableOfContent'>
          <li>定义</li>
          <li>我们如何收集和使用个人信息</li>
          <li>Cookies及同类技术的使用</li>
          <li>我们如何共享、转让、公开披露个人信息</li>
          <li>个人信息的储存</li>
          <li>我们如何保护个人信息</li>
          <li>您的权利</li>
          <li>我们如何处理未成年人的个人信息</li>
          <li>本政策如何更新</li>
          <li>如何联系我们</li>
        </ol>
      </div>
      <div className='textContent'>
        <ol className='firstLevelOl'>
          <li>定义</li>
          <ol className='secondLevelOl'>
            <li>1.1 索迪斯优e+营养餐解决方案（以下简称“系统”）</li>
            <p>指由索迪斯提供的、专门用于为住院病人及其家属提供线上订餐、结算等服务的网络系统。</p>
            <li>1.2 索迪斯</li>
            <p>指所有隶属于索迪斯集团的在中国境内的持股公司及其所有分公司。</p>
            <li>1.3 医院/院方</li>
            <p>指由索迪斯提供餐饮服务，并实际投入使用索迪斯优e+营养餐解决方案的各医院。</p>
            <li>1.4 开发商</li>
            <p>指为索迪斯开发优e+营养餐解决方案并提供日常运营与维护的供应商。</p>
            <li>1.5 第三方存储平台</li>
            <p>指非索迪斯或供应商运营的第三方数据存储平台。</p>
            <li>1.6 个人信息</li>
            <p>指以电子或者其他方式记录的能够单独或者与其他信息结合识别特定自然人身份或者反映特定自然人活动情况的各种信息，不包括匿名化处理后的信息。</p>
            <li>1.7 个人敏感信息</li>
            <p>指一旦泄露、非法提供或滥用可能危害人身和财产安全，极易导致个人名誉、身心健康受到损害或歧视性待遇等的个人信息，包括但不限于身份证件号码、个人生物识别信息、银行账号、财产信息、行踪轨迹、交易信息、14周岁（含）儿童信息等的个人信息。</p>
            <li>1.8 个人信息删除</li>
            <p>指在实现日常业务功能所涉及的系统及存档中去除个人信息的行为，不再留存相关个人信息。</p>
          </ol>
          <li>我们如何收集和使用个人信息</li>
          <p>如您为本系统的住院病员用户，我们会直接通过您的院方（指您本次就医的医疗机构）收集和处理您的个人信息，亦会直接向您（例如在您使用本系统的过程中）收集和处理个人信息。我们仅会出于本政策所述的以下目的，收集、储存和使用个人信息：</p>
          <ol className='secondLevelOl'>
            <li>2.1 院方向我们提供的与您相关的个人信息</li>
            <p>为确保餐饮服务的正常提供，识别订餐人员、用餐忌口、配送地点等功能，院方已将以下住院病员的个人信息提供给索迪斯：</p>
            <ol className='thirdLevelOl'>
              <li>(a) 身份信息:姓名、出生年月；</li>
              <li>(b) 配送地址信息:病房与床位；</li>
              <li>(c) 住院信息:住院号、入院出院时间；</li>
              <li>(d) 饮食医嘱:包括饮食忌口与过敏源。</li>
            </ol>
            <li>2.2 我们直接向您收集的个人信息</li>
            <p>为确保餐食的及时送达，为与您及时取得联系，我们将收集您的以下个人信息：</p>
            <ol className='thirdLevelOl'>
              <li>(a) 联系方式:手机号码；</li>
            </ol>
            <p style={{ textDecoration: 'underline', fontWeight: 'bold' }}>
              您理解并同意，院方向我们提供您的任何个人信息之前，已经事先获得您的明确授权，其收集您个人信息的范围限于实现本政策所述目的或实现院方与我们之间订立的其他协议的目的之必要范围，院方已充分告知您收集您的个人信息的目的、范围、使用方式等。如您无法确认本款内容，请立即停止使用本服务，并与您就诊的院方就前述事项进行确认。
            </p>
            <p style={{ textDecoration: 'underline', fontWeight: 'bold' }}>
              索迪斯从院方收到您的个人信息时，默认您已知悉并同意索迪斯就收到的个人信息以本政策所描述之目的与处理方式进行处理。若您尚未就院方将您个人信息提供给索迪斯并用于本政策所描述之目的进行处理而进行过任何授权，则当您同意本政策所述之内容时，我们将认为您对索迪斯从院方处得到您的个人信息并处理表达了认可与同意。
            </p>
            <li>2.3 您直接向我们提供的个人信息</li>
            <p>如您不是本系统的住院病院用户，而属于其他人员用户（例如病员家属），为了确保餐饮服务的正常提供，我们提供订餐与配送服务，将直接向您收集以下您的及您探望的住院病员用户的如下个人信息：</p>
            <ol className='thirdLevelOl'>
              <li>(a) 身份信息:住院病员的姓名；</li>
              <li>(b) 联系方式:手机号码；</li>
              <li>(c) 配送地址信息：住院病员的病房与床位</li>
            </ol>
            <li>2.4 我们在您使用系统的过程收集的信息</li>
            <p>索迪斯致力于为您提供安全、可行、舒适以及可靠的服务。为实现本订餐系统功能，我们将会在您使用系统的过程中收集以下信息：</p>
            <ol className='thirdLevelOl'>
              <li>(a) 订餐记录；</li>
              <li>(b) 付款记录；</li>
            </ol>
            <p style={{ textDecoration: 'underline', fontWeight: 'bold' }}>
              您理解并同意，我们将根据您每次订餐的菜品选择（订餐记录），对您所订菜品进行营养分析，并将分析结果于送餐时通过各种方式告知与您。我们将仅为营养分析之目的而对您的订餐记录进行分析，不会为了其他目的而进行其他处理或使用。
            </p>
            <p style={{ textDecoration: 'underline', fontWeight: 'bold' }}>
              若您提供的信息中含有其他用户的个人信息，在本系统中输入前述个人信息之前，您需确保您已经取得合法的授权。
            </p>
            <p style={{ textDecoration: 'underline', fontWeight: 'bold' }}>
              若我们将信息用于本政策未载明的其它用途，或者将您的个人信息用于本政策所描述目的以外的其它目的，均会事先征得您的同意。
            </p>
            <li>2.5 征得授权同意的例外</li>
            <p>根据相关法律法规规定，以下情形中收集个人信息无需征得个人信息主体的授权同意：</p>
            <ol className='thirdLevelOl'>
              <li>(a) 与我们履行法律法规规定的义务相关的；</li>
              <li>(b) 与国家安全、国防安全直接相关的；</li>
              <li>(c) 与公共安全、公共卫生、重大公共利益有直接相关的；</li>
              <li>(d) 与犯罪侦查、起诉、审判和判决执行等直接相关的；</li>
              <li>(e) 出于维护您或其他个人的生命、财产等重大合法权益但又很难得到您本人同意的；</li>
              <li>(f) 所收集的个人信息是您自行向社会公众公开的；</li>
              <li>(g) 根据您要求签订和履行合同所必需的；</li>
              <li>(h) 从合法公开披露的信息中收集个人信息的，如合法的新闻报道、政府信息公开等渠道；</li>
              <li>(i) 维护所提供的产品或服务的安全稳定运行所必需的，例如发现、处置产品或服务的故障；</li>
              <li>(j) 法律法规规定的其他情形。</li>
            </ol>
            <p>如我们停止运营平台的产品或服务，我们将及时停止继续收集您个人信息的活动，对所持有的个人信息进行删除或匿名化处理。</p>
          </ol>
          <li>Cookies及同类技术的使用</li>
          <ol className='secondLevelOl'>
          <li>3.1 Cookie及Cookie同类技术</li>
          <p>我们使用 Cookie及同类技术（下称“Cookie”）以记录您的登录账号。Cookie 是一种文本文件，放置在您的设备上的Cookie能够让您更便捷地访问本系统。关于我们Cookie政策的更多信息，请访问<a href="https://cn.sodexo.com/home/terms-and-conditions/cookie-policy.html">Cookie政策</a>。</p>
          </ol>
          <li>我们如何共享、转让、公开披露您的个人信息</li>
          <ol className='secondLevelOl'>
            <li>4.1 共享</li>
            <p>我们不会与供应商及第三方存储平台以外的任何公司、组织和个人分享您的个人信息，但以下情况除外：</p>
            <ol className='thirdLevelOl'>
              <li>4.1.1 在获取明确同意的情况下共享：获得您的明确同意后，我们会与其他方共享您的个人信息。</li>
              <li>4.1.2 我们可能会根据法律法规规定，或按政府主管部门的强制性要求，对外共享您的个人信息。</li>
              <li>4.1.3 与索迪斯关联公司共享：为便于我们基于关联账号共同向您提供服务，保护索迪斯关联公司或公众的人身财产安全免遭侵害，您的个人信息可能会与索迪斯关联公司共享。我们只会共享必要的个人信息（如为便于您通过同一账号使用我们关联公司产品或服务，我们会向关联公司共享您必要的账户信息），如果我们共享您的个人敏感信息或关联公司改变个人信息的使用及处理目的，将再次征求您的授权同意。</li>
              <li>4.1.4 与授权合作伙伴共享：仅为实现根本服务目的、本政策中声明的目的，我们可能会与必要的服务合作伙伴，如提供软件开发与维护的供应商之间共享您的个人信息，以提供更好的客户服务和用户体验。我们仅会出于合法、正当、必要、特定、明确的目的共享您的个人信息，并且只会共享提供服务所必要的个人信息。我们的合作伙伴无权将共享的个人信息用于任何其他用途。如果您拒绝我们向我们的合作伙伴分享为提供服务所必须的个人信息，将可能导致您无法在平台中使用对应的服务。
                <p>目前，本系统的授权合作伙伴包括以下类型：</p>
                <ol className='forthLevelOl'>
                  <li>(a) 软件供应商。供应商为软件开发、技术升级、日常维护等必要的服务目的，可以接触并获得我们所收集的个人信息，并对该信息进行本地备份。</li>
                </ol>
                <p>对我们与之共享个人信息的公司、组织和个人，我们会与其签署严格的保密协定，要求他们按照我们的说明、声明个人信息保护政策以及其他任何相关的保密和安全措施来处理个人信息。</p>
                <ol className='forthLevelOl'>
                  <li>(b) 云端存储。我们为存储与备份您的和/或您孩子的个人信息，会将该信息上传至云端。</li>
                </ol>
                <p>对我们与之共享个人信息的公司、组织和/或个人，我们会与其签署严格的保密协定，要求他们按照我们的说明、声明个人信息保护政策以及其他任何相关的保密和安全措施来处理个人信息。</p>
              </li>
            </ol>
            <li>4.2 我们如何转让个人信息</li>
            <p>我们不会将您的个人信息转让给任何公司、组织和个人，但以下情况除外：</p>
            <ol className='thirdLevelOl'>
              <li>4.2.1 在获取明确同意的情况下转让：获得您的明确同意后，我们会向其他方转让您的个人信息；</li>
              <li>4.2.2 在平台服务提供者发生合并、收购或破产清算情形，或其他涉及合并、收购或破产清算情形时，我们会向您告知有关个人信息的处理情况；如涉及到个人信息转让，我们会在要求新的持有您个人信息的公司、组织继续受本政策的约束，并保持个人信息使用目的不变，否则我们将要求该公司、组织重新向您征求授权同意。</li>
            </ol>
            <li>4.3 公开披露</li>
            <p>我们不会公开披露您的个人信息，但以下情况除外：</p>
            <ol className='thirdLevelOl'>
              <li>4.3.1 获得您的明确同意或基于您的主动选择，我们可能会公开披露该个人信息；</li>
              <li>4.3.2 基于法律、法律程序、诉讼或政府主管部门强制性要求的情况下，我们可能会向有权机关披露您的个人信息。</li>
            </ol>
            <li>4.4 共享、转让、公开披露个人信息时事先征得授权同意的例外</li>
            <p>以下情形中，共享、转让、公开披露您的个人信息无需事先征得您的授权同意：</p>
            <ol className='thirdLevelOl'>
              <li>(a) 与我们履行法律法规规定的义务相关的；</li>
              <li>(b) 与国家安全、国防安全直接相关的；</li>
              <li>(c) 与公共安全、公共卫生、重大公共利益直接相关的；</li>
              <li>(d) 与犯罪侦查、起诉、审判和判决执行等直接相关的；</li>
              <li>(e) 出于维护您或其他个人的生命、财产等重大合法权益但又很难得到您本人同意的；</li>
              <li>(f) 您自行向社会公众公开的个人信息；</li>
              <li>(g) 从合法公开披露的信息中收集个人信息的，如合法的新闻报道、政府信息公开等渠道；</li>
              <li>(h) 法律法规规定的其他情形；</li>
            </ol>
            <p style={{ textDecoration: 'underline', fontWeight: 'bold' }}>
              根据法律规定，共享、转让经去标识化处理的个人信息，且确保数据接收方无法复原并重新识别个人信息主体的，不属于个人信息的对外共享、转让及公开披露行为，对此类数据的保存及处理将无需另行向您通知并征得您的同意。
            </p>
          </ol>
          <li>个人信息的储存</li>
          <ol className='secondLevelOl'>
            <li>5.1 我们在中华人民共和国（本政策中不包括香港、澳门及台湾地区）境内运营中收集和产生的个人信息，存储在中国境内。</li>
            <li>5.2 您的个人信息，除订餐与付款记录以外，将会以脱敏的形式进行存储。</li>
            <p style={{ textDecoration: 'underline', fontWeight: 'bold' }}>
              若您超过7天未进行任何订餐操作，则我们将默认您已出院，您的账户将会被自动注销，所有数据转入存档。
            </p>
            <p style={{ textDecoration: 'underline', fontWeight: 'bold' }}>
              存档期间仅有索迪斯内部系统负责人能够访问、读取和调用该信息。存档期限为三年，三年后若无其他需要或后续活动，则该信息将被彻底匿名化处理或被删除。
            </p>
            <li>5.3 存档期间对您的数据非经特别程序申请不得调取或处理。对于超出期限的个人信息，我们会立即删除或做匿名化处理。如我们因经营不善或其他原因出现停止运营的情况，我们会立即停止对您个人信息的收集，删除已收集的个人信息。我们会将此情况在网站上进行公告或以站内信、邮件等其他合理方式逐一传达到各个用户。</li>
          </ol>
          <li>我们如何保护个人信息</li>
          <ol className='secondLevelOl'>
            <li>6.1 我们已采取符合业界标准、合理可行的安全防护措施保护您提供的个人信息安全。我们会使用加密技术和防火墙提高个人信息的安全性；我们会使用受信赖的保护机制防止个人信息遭到恶意攻击；我们会部署访问控制机制；以及我们会举办安全和隐私保护培训课程，加强员工对于保护个人信息重要性的认识。但请您理解，由于技术的限制以及可能存在的各种恶意手段，在互联网行业，即便竭尽所能加强安全措施，也不可能始终保证信息百分之百的安全。您需要了解，您接入我们的服务所用的系统和通讯网络，有可能因我们可控范围外的因素而出现问题。</li>
            <li>6.2 我们会采取合理可行的措施，尽力避免收集无关的个人信息。我们只会在达成本政策所述目的所需的期限内保留您的个人信息，除非需要延长保留期或受到法律的允许。</li>
            <li>6.3 互联网并非绝对安全的环境，我们强烈建议您不要使用非我们推荐的通信方式发送个人信息。</li>
            <p style={{ textDecoration: 'underline', fontWeight: 'bold' }}>
              请您妥善保护自己的个人信息，仅在必要的情形下向他人提供。如您发现自己的个人信息尤其是您的账户或密码发生泄露，请您立即联络我们，以便我们根据您的申请采取相应措施。
            </p>
            <p style={{ textDecoration: 'underline', fontWeight: 'bold' }}>
              请注意，您在使用我们服务时自愿共享甚至公开分享的信息，可能会涉及您或他人的个人信息甚至个人敏感信息。请您更加谨慎地考虑，是否在使用我们的服务时共享甚至公开分享相关信息。若您需要删除您的个人信息，您可以联系我们，我们将帮助您删除您指定的内容。
            </p>
            <p style={{ textDecoration: 'underline', fontWeight: 'bold' }}>
              我们将尽力保障您发送给我们的任何信息的安全性。如果我们的物理、技术或管理防护设施遭到破坏，导致信息被非授权访问、公开披露、篡改或毁坏，导致您的合法权益受损，我们将承担相应的法律责任。
            </p>
            <li>6.4 我们将不定期更新并公开安全风险、个人信息安全影响评估报告等有关内容，您可通过本平台公告方式获得。</li>
            <li>6.5 在不幸发生个人信息安全事件后，我们将按照法律法规的要求进行处理，包括向您告知：安全事件的基本情况和可能的影响、我们已采取或将要采取的处置措施、您可自主防范和降低风险的建议、对您的补救措施等。我们将以站内信、邮件等方式告知您安全事件的有关情况，如果难以逐一告知所涉及的个人信息主体，我们会采取合理、有效的方式发布公告。同时，我们还将依据监管部门的要求，将安全事件的处置情况予以上报。</li>
          </ol>
          <li>您的权利</li>
          <p>您可以通过以下方式行使您的个人权利（未穷尽列举）：</p>
          <ol className='secondLevelOl'>
            <li>7.1 查询、更正和补充</li>
            <p>除法律法规规定的例外情况外，您有权访问、更正和补充您的个人信息。您可以通过发送邮件至dpo.china@sodexo.com要求访问、更正和补充您的个人信息。我们将在15个工作日内回复您的问询。</p>
            <li>7.2 删除个人信息</li>
            <p>在以下情形中，您可以发邮件至 dpo.china@sodexo.com向我们提出删除您的和/或您孩子的个人信息的请求：</p>
            <ol className='thirdLevelOl'>
              <li>(a) 我们的处理目的已实现、无法实现或者为实现处理目的不再必要；</li>
              <li>(b) 我们停止提供产品或服务，或者保存期限届满；</li>
              <li>(c) 您撤回您的同意；</li>
              <li>(d) 我们处理个人信息的行为违反法律、行政法规或违反约定；</li>
              <li>(e) 法律、行政法规规定的其他情形。</li>
            </ol>
            <p>我们将在15个工作日内回复您。</p>
            <p>在这种情况下，若我们决定响应您的删除请求，我们将尽可能通知从我们处获得您的个人信息的主体，要求其及时删除，除非法律法规另有规定，或这些主体获得您的独立授权。</p>
            <p>当您从我们的服务中删除信息后，我们可能不会立即从备份系统中删除相应的信息，但会在备份更新时删除这些信息。</p>
            <li>7.3 改变授权同意的范围</li>
            <p>除法律法规规定的例外情况外，您有权改变或撤回您授权我们收集和处理您的和/或您孩子的个人信息的范围。您可以通过发送邮件至dpo.china@sodexo.com实现您的前述权利。我们将在15个工作日内回复您。</p>
            <li>7.4 获取个人信息副本</li>
            <p>您有权获取您的个人信息副本，您可以通过发送邮件至dpo.china@sodexo.com的方式，告知我们您的要求与具体内容，我们将在15个工作日内回复。</p>
            <li>7.5 注销账户</li>
            <p>您有权注销您的账户，您可以通过发送邮件至dpo.china@sodexo.com的方式实现该权利，我们将在15个工作日内回复。</p>
            <p>在收到您注销账户的请求后，我们将停止为您提供产品和/或服务，并依据适用法律的要求删除您的和/或你孩子的个人信息，或对其进行匿名化处理。</p>
            <li>7.6 响应您的上述请求</li>
            <p>为保障安全，您可能需要提供书面请求，或以其他方式证明您的身份。我们可能会先要求您验证自己的身份，然后再处理您的请求。</p>
            <p>我们将在15个工作日内做出答复。如您不满意，还可以通过向我们提出投诉。</p>
            <p style={{ textDecoration: 'underline', fontWeight: 'bold' }}>
              对于无端重复、需要过多技术手段（例如，需要开发新系统或从根本上改变现行惯例）、给他人合法权益带来风险或者非常不切实际的请求，我们可能会予以拒绝。
            </p>
          </ol>
          <li>我们如何处理未成年人的个人信息</li>
          <p style={{ textDecoration: 'underline', fontWeight: 'bold' }}>如果没有父母或监护人的同意，未成年人不得使用该索迪斯优e+营养解决方案微信端系统功能。如您为未成年人的，请由您的父母或监护人仔细阅读本个人信息保护政策，并在征得您的父母或监护人同意的前提下使用我们的服务或向我们提供信息。</p>
          <p style={{ textDecoration: 'underline', fontWeight: 'bold' }}>对于经父母或监护人同意使用我们的产品或服务而收集未成年人个人信息的情况，我们只会在法律法规允许、父母或监护人明确同意或者保护未成年人所必要的情况下使用、共享、转让或披露此信息。</p>
          <p style={{ textDecoration: 'underline', fontWeight: 'bold' }}>如您为未成年人的，请由您的父母或其他监护人仔细阅读本政策，并在征得您的父母或其他监护人同意的前提下使用我们的服务或向我们提供信息。</p>
          <p style={{ textDecoration: 'underline', fontWeight: 'bold' }}>如您为14周岁（含）以下儿童的，在您使用我们的服务前，您和您的监护人应仔细阅读我们专门指定的《儿童个人信息保护规则》，确保取得您的父母或其他监护人对前述《儿童个人信息保护规则》的同意后，您方可在您的父母或其他监护人的指导下使用我们的服务，确保您在使用我们的服务时的安全。</p>
          <p style={{ textDecoration: 'underline', fontWeight: 'bold' }}>若您是儿童的父母或其他监护人的，请您关注您监护的儿童是否是在取得您的授权同意后使用我们的服务的。如您对您所监护的儿童的个人信息有疑问，请发邮件至dpo.china@sodexo.com，以便与我们取得联系。</p>
          <li>本政策如何更新</li>
          <p>我们的个人信息保护政策可能变更。</p>
          <p>未经您明确同意，我们不会削减您按照声明和隐私所应享有的权利。我们会在本页面上发布对本政策所做的任何变更。</p>
          <p>对于重大变更，我们还会提供更为显著的通知（包括我们会通过网站公示的方式进行通知甚至向您提供弹窗提示）并获取同意。</p>
          <p>本政策所指的重大变更包括但不限于：</p>
          <ol className='secondLevelOl'>
            <li>(a) 我们的服务模式发生重大变化。如处理个人信息的目的、处理的个人信息类型、个人信息的使用方式等；</li>
            <li>(b) 我们在所有权结构、组织架构等方面发生重大变化。如业务调整、破产并购等引起的所有者变更等；</li>
            <li>(c) 个人信息共享、转让或公开披露的主要对象发生变化；</li>
            <li>(d) 您参与个人信息处理方面的权利及其行使方式发生重大变化；</li>
            <li>(e) 我们负责处理个人信息安全的责任部门、联络方式及投诉渠道发生变化时；</li>
            <li>(f) 个人信息安全影响评估报告表明存在高风险时。</li>
            <p>我们还会将本政策的旧版本存档，供您查阅。</p>
          </ol>
          <li>如何联系我们</li>
          <p>您可以通过邮件（dpo.china@sodexo.com）与我们联系，一般情况下我们将在15个工作日内回复您的来件。<span className='bold'>需注意的是，我们可能不会回复与本政策或你的个人信息权利无关的问题。</span></p>
          <p>如您对我们的回复不满意，尤其当您认为我们的个人信息处理行为损害了您的合法权益，<span className='bold'>您还可以通过向有管辖权的法院提起诉讼来寻求解决方案。</span></p>
        </ol>
      </div>
    </div>
  )
}
